import { render, staticRenderFns } from "./realEstateManagement.vue?vue&type=template&id=ca37fafc&"
import script from "./realEstateManagement.vue?vue&type=script&lang=js&"
export * from "./realEstateManagement.vue?vue&type=script&lang=js&"
import style0 from "./realEstateManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports